<template>
  <v-system-bar v-if="isDev" app dark color="purple">
    <v-icon>mdi-wrench</v-icon>
    <span>
      Dev Mode
    </span>
    <v-spacer></v-spacer>
    <span class="mr-4 caption">
      <v-switch
        id="debug-toggle"
        :input-value="debugToggle"
        @change="toggleDebugMode"
      >
        <template v-slot:label>
          <span class="caption">Enable Debug Mode</span>
        </template>
      </v-switch>
    </span>

    <span v-if="!isMobileViewPort" class="mr-4">
      <v-icon>mdi-code-tags</v-icon>
      <span>{{ `v${appVersion}` }}</span>
    </span>
  </v-system-bar>
</template>

<script>
import baseMixin from '@/mixins/baseMixin'
import config from '@/common/config'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TheDebugBar',
  mixins: [baseMixin],
  data() {
    return {
      debugToggle: this.isDebug,
      appVersion: config.get('appVersion'),
    }
  },
  computed: {
    ...mapGetters({
      serverError: 'isError',
    }),
  },
  mounted() {
    this.debugToggle = this.isDebug
  },
  methods: {
    ...mapActions({
      toggleDebug: 'toggleDebugMode',
    }),
    toggleDebugMode() {
      this.toggleDebug()
    },
  },
}
</script>
